export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat účet navrhovatele"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet navrhovatele"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}